
















































import { defineComponent, PropType, computed } from '@vue/composition-api';
import { AreaItem } from '@tt4b/ttam-enums';
import { DISPLAY_NUMBER } from '../const';
const name = 'ttam-location-undo-current-changes';
export default defineComponent({
  name,
  props: {
    from: {
      type: Object as PropType<{
        displayLocations: string;
        totalCount: number;
        moreCount: number;
      }>,
      default: () => ({
        totalCount: 0,
        moreCount: 0,
        displayLocations: '',
      }),
    },
    to: {
      type: Object as PropType<{
        displayLocations: string;
        totalCount: number;
        moreCount: number;
      }>,
      default: () => ({
        totalCount: 0,
        moreCount: 0,
        displayLocations: '',
      }),
    },
    displayNumber: {
      type: Number,
      default: DISPLAY_NUMBER,
    },
    visibleCurrentChangeTip: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { displayNumber } = props;
    const fromLength = computed(() => props.from.totalCount);
    const toLength = computed(() => props.to.totalCount);
    const isFromOneToOne = computed(() => {
      console.log('isFromOneToOne', props.from, props.to);
      return fromLength.value <= displayNumber && toLength.value <= displayNumber;
    });
    const isFromMoreToOne = computed(() => fromLength.value > displayNumber && toLength.value <= displayNumber);
    const isFromOneToMore = computed(() => fromLength.value <= displayNumber && toLength.value > displayNumber);
    const isFromMoreToMore = computed(() => fromLength.value > displayNumber && toLength.value > displayNumber);
    const fromPlace = computed(() => props.from.displayLocations);
    const toPlace = computed(() => props.to.displayLocations);
    const moreFromCount = computed(() => props.from.moreCount);
    const moreToCount = computed(() => props.to.moreCount);
    const handleUndoClick = () => {
      emit('undo');
    };
    return {
      name,
      isFromOneToOne,
      isFromMoreToOne,
      isFromMoreToMore,
      isFromOneToMore,
      handleUndoClick,
      fromPlace,
      toPlace,
      moreFromCount,
      moreToCount,
    };
  },
});
